export default "__VITE_ASSET__BTbsKkPS__"